module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-start-selling-armchair-7933290bcdb6eb619e6d45370d73de10.png";